<template>
  <div
    class="markdown tutorial">
    <div 
      v-for="(section,i) in sections"
      :key="`section_${i}`">
      <template v-if="section.type==='title'">
        <h1>{{ section.value }}</h1>
      </template>
      <template v-else-if="section.type==='text'">
        <span v-html="section.value" />
      </template>
      <template v-else-if="section.type==='index'">
        <h2>{{ section.value }}</h2>
        <div 
          v-for="(section,j) in sections"
          v-if="section.type==='list'"
          :key="`index_${j}`">
          - <a :href="`#${section.value}`">{{ section.value }}</a>
        </div>
      </template>
      <template v-else-if="section.type==='subtitle'">
        <h3>{{ section.value }}</h3>
      </template>
      <template v-else-if="section.type==='list'">
        <div 
          :id="section.value"
          class="mb-3"/>
        <h2>{{ section.value }}</h2>
        <div 
          v-if="section.text" 
          v-html="section.text"/>
        <v-layout 
          wrap
          row>
          <v-flex 
            v-for="(item,i) in section.items"
            :key="`item_${i}`"
            d-flex
            class="xs12 md4 pr-2 py-2">
            <v-card 
              class="elevation-1">
              <v-card-title 
                class="tutorial-list">
                <span class="list-number">{{ i + 1 }}.</span>
                <span v-html="item.text"/>
              </v-card-title>
              <v-card-text class="text-xs-center">
                <img 
                  :src="item.image" 
                  width="240px" >
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </template>
      <template v-else-if="section.type==='text-list'">
        <h3>{{ section.value }}</h3>
        <ul>
          <li
            v-for="(item ,i) in section.items"
            :key="`text-list-${i}`">
            <span v-html="item"/>
          </li>
        </ul>
      </template>
      <template v-else>
        [[ {{ section.type }} ]]
      </template>
    </div>
  </div>
</template>

<script>
// import marked from 'marked'
// const debug = require('debug')('OD::Tutorial')

export default {
  name: 'Tutorial',
  components: {},
  props: {},
  data() {
    return {
      title: 'Tus primeros pasos',
      sections: [
        {
          type: 'title',
          value: 'Tus primeros pasos',
        },
        {
          type: 'text',
          value:
            'A continuación describiremos los pasos que debes realizar para poder crear y gestionar tu club',
        },
        {
          type: 'index',
          value: 'Índice',
        },
        {
          type: 'list',
          value: 'Logarse',
          items: [
            {
              text: 'Logarte en la web, para ello puedes utilizar Google o Facebook',
              image:
                'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/manual%2FNoLogged_menu.png?alt=media&token=0e3cba2e-fd3c-4fa0-a755-4f39c7c9f754',
            },
          ],
        },
        {
          type: 'list',
          value: 'Crear el club',
          items: [
            {
              text: 'Pulsar sobre el botón "Crear nuevo club/evento.',
              image:
                'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/manual%2FcreateClub_button.png?alt=media&token=0aa61400-3914-4836-916c-3d8748632380',
            },
            {
              text:
                'Solicita tu código de invitacion mandando un email a <a href="mailto:siguetuclub@gmail.com">siguetuclub@gmail.com</a>.',
              image:
                'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/manual%2Finvitation_code.png?alt=media&token=d58482a3-1225-4f38-ad39-e1e49849c16e',
            },
            {
              text: 'Completa los datos de tu club.',
              image:
                'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/manual%2Fclub_creation_form.png?alt=media&token=b32f2b78-0591-4710-8b58-3d2dcf2f9d7d',
            },
          ],
        },
        {
          type: 'list',
          value: 'Gestionar tu club',
          items: [
            {
              text:
                'Una vez creado tu club, en la parte inferior derecha te aparecerá el botón de gestión, pulsa sobre la primera opción.',
              image:
                'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/manual%2Fadmin_options_menu.png?alt=media&token=58dfce75-0376-43e2-9e82-ddc0d859506b',
            },
            {
              text: 'Podemos editar los datos del club.',
              image:
                'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/manual%2Fedit_club.png?alt=media&token=55ff40ed-7d25-49d4-9dca-6d6384c31a9f',
            },
          ],
        },
        {
          type: 'list',
          value: 'Gestionar usuarios administradores y editores',
          items: [
            {
              text:
                'Una vez creado tu club, en la parte inferior derecha te aparecerá el botón de gestión, pulsa sobre la segunda opción.',
              image:
                'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/manual%2Fadmin_options_menu.png?alt=media&token=58dfce75-0376-43e2-9e82-ddc0d859506b',
            },
            {
              text: 'Acceder a la sección de gestión de usuarios.',
              image:
                'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/manual%2Fadmin_users2.png?alt=media&token=52820390-3605-4c75-981e-2f6b266215ae',
            },
            {
              text: 'Añadir nuevos usuarios administradores, editores o visores.',
              image:
                'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/manual%2Fadd_user.png?alt=media&token=d293f4b3-f11e-424b-8e6d-c251c5bd518d',
            },
            {
              text: 'Selecciona el tipo de perfil del usuario.',
              image:
                'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/manual%2Fadd_user_options.png?alt=media&token=d4a03713-0573-4747-a3e1-faff4d2f4f70',
            },
          ],
        },
        {
          type: 'text-list',
          value: 'Tipos de perfil de usuario',
          items: [
            '<strong>Admninsitrador:</strong> Puede crear partidos y nuevos usuarios, gestionar los partidos y acceso a estadísticas por jugador.',
            '<strong>Editor:</strong> Puede gestionar los partidos (marcadores) y acceso a estadísticas por jugador.',
            '<strong>Visor:</strong> Sólamente tiene acceso a las estadísticas por jugador',
          ],
        },
        {
          type: 'list',
          value: 'Crear partidos',
          items: [
            {
              text:
                'Una vez creado tu club, en la parte inferior derecha te aparecerá el botón de gestión, pulsa sobre la tercera opción.',
              image:
                'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/manual%2Fadmin_options_menu.png?alt=media&token=58dfce75-0376-43e2-9e82-ddc0d859506b',
            },
            {
              text: 'Crear un nuevo partido.',
              image:
                'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/manual%2Fcreate_match.png?alt=media&token=d7ec3e74-1df1-430d-99d0-f2d15ee99a4d',
            },
            {
              text: 'Añade nuevas categorias pulsando sobre el botón de +.',
              image:
                'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/manual%2Fcreate_category.png?alt=media&token=ca22b5ad-efd3-4c6f-a49d-54591ab35b3a',
            },
            {
              text: 'Añade nuevos equipos pulsando sobre el botón de +.',
              image:
                'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/manual%2Fcreate_team.png?alt=media&token=28e1b2a6-9f59-46f7-b159-143b2370ba97',
            },
            {
              text: 'Añade nuevas localizaciones pulsando sobre el botón de +.',
              image:
                'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/manual%2Fcreate_location.png?alt=media&token=b8945f79-5a77-4e55-ab94-789d257897c2',
            },
          ],
        },
        {
          type: 'list',
          value: 'Gestionar los marcadores',
          text:
            'Si eres un usuario administrador o editor tendrás acceso a los paneles de gestión del partido.',
          items: [
            {
              text: 'Marcador básico, únicamente se puede añadir puntos a un equipo u otro.',
              image:
                'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/manual%2Fvoleyball_basic.png?alt=media&token=fe8c3285-17eb-4ead-bf21-6d757f1c0f2f',
            },
            {
              text: 'Marcador avanzado, te permite indicar qué acción ha realizado el punto.',
              image:
                'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/manual%2Fvolleyball_advanced.png?alt=media&token=a9973355-64a9-426f-88a7-c3f6beb47e06',
            },
            {
              text: 'Marcador pro, te permite indicar qué jugador ha realizado la acción.',
              image:
                'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/manual%2Fvoleyball_pro.png?alt=media&token=5d918732-f9b6-4a1f-b03a-a6a7129c4f5a',
            },
            {
              text:
                'Opciones: editar el partido o si eres usuario administrador bloquearlo una vez finalizado.',
              image:
                'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/manual%2Fmatch_options.png?alt=media&token=c97d949e-5535-4a7e-82b4-8a60ec149ce0',
            },
          ],
        },
        {
          type: 'list',
          value: 'Informacion extra del partido',
          text:
            'Podemos acceder a información más detallada pulsando sobre las opciones que aparecen debajo del marcador',
          items: [
            {
              text: 'Leyenda. ',
              image:
                'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/manual%2Fmatch_leyend.png?alt=media&token=4f539837-847b-4df1-ac7e-ebe94d5f742e',
            },
            {
              text: 'Estadísticas del partido.',
              image:
                'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/manual%2Fmatch_stats.png?alt=media&token=dcaec60b-71ae-417e-b4c7-e393d69bfe99',
            },
            {
              text: 'Gráficas del partido.',
              image:
                'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/manual%2Fmatch_graphs.png?alt=media&token=41810ac1-fd18-47ca-97dc-842a5aac78e1',
            },
            {
              text: 'Resumen del partido.',
              image:
                'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/manual%2Fmatch_summary.png?alt=media&token=80f2a630-4f5f-4fb4-a23a-27619e469a6c',
            },
            {
              text: 'Estadísticas por jugador.',
              image:
                'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/manual%2Fmatch_stat_player.png?alt=media&token=211beb59-6e70-4a09-b5ea-be17b4891a79',
            },
          ],
        },
        {
          type: 'list',
          value: 'Marcadores',
          text: 'Ejemplos de marcadores por deporte',
          items: [
            {
              text: 'Voleibol',
              image:
                'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/manual%2Fvoleyball_advenced_short.png?alt=media&token=47e8d267-aa7d-4e7f-906b-d6655bd0fcc7',
            },
            {
              text: 'Rugby',
              image:
                'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/manual%2Frugby_advanced.png?alt=media&token=d3e649c7-4c42-4491-9761-d872db456993',
            },
            {
              text: 'Balonmano',
              image:
                'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/manual%2Fhandball_advanced.png?alt=media&token=ce09e2f3-cb1b-4195-88ba-1fc484c3cb41',
            },
            {
              text: 'Baseball/Softball',
              image:
                'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/manual%2Fbaseball_advanced.png?alt=media&token=dd2fc22c-247d-4f4f-99d6-7500fc7dd603',
            },
            {
              text: 'Baloncesto',
              image:
                'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/manual%2Fbasketball_advanced.png?alt=media&token=ebdf1150-6fde-487c-8019-35a2be784366',
            },
          ],
        },
      ],
    }
  },
  computed: {},
  watch: {},
  created() {},
  methods: {},
}
</script>
<style lang="scss">
.tutorial-list {
  span {
    display: contents;
  }

  .list-number {
    font-weight: bold;
    font-size: 1.2em;
  }
}
</style>
